import { render, staticRenderFns } from "./XkzBgfqkTj.vue?vue&type=template&id=43b5e63c&scoped=true&"
import script from "./XkzBgfqkTj.vue?vue&type=script&lang=js&"
export * from "./XkzBgfqkTj.vue?vue&type=script&lang=js&"
import style0 from "./XkzBgfqkTj.vue?vue&type=style&index=0&id=43b5e63c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b5e63c",
  null
  
)

export default component.exports